module.exports = __webpack_public_path__ + "images/bannerPT-f87c8fa7bc0a9eadfe4bfc806c8d8673.jpg";